export const PROJECT_AUDIENCE_FETCHING = 'PROJECT_AUDIENCE_FETCHING';
export const PROJECT_AUDIENCE_FETCH_SUCCESS = 'PROJECT_AUDIENCE_FETCH_SUCCESS';
export const PROJECT_AUDIENCE_FETCH_FAILED = 'PROJECT_AUDIENCE_FETCH_FAILED';

export const PROJECT_AUDIENCE_SELECT = 'PROJECT_AUDIENCE_SELECT';
